(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cove-covered-set"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cove-covered-set-picker')) {
  customElements.define('cove-covered-set-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.querySelector('[data-bundle-select]').addEventListener('change', event => {
        const choice = event.target.selectedOptions[0];
        const button = this.querySelector('[data-bundle-add]');
        const available = choice.dataset.available === 'true';
        this.querySelector('[data-bundle-price]').textContent = choice.dataset.price;
        button.disabled = !available;
        button.textContent = available ? button.dataset.addLabel : button.dataset.pendingLabel;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cove-video-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cove-video-hero')) {
    customElements.define('cove-video-hero', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        if (!this.video || !this.button) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.motion.matches || Boolean(navigator.connection?.saveData);
        this.visible = true;
        this.video.muted = true;
        this.video.controls = false;
        this.button.hidden = false;
        this.updateControl = () => {
          const playing = !this.video.paused && !this.video.ended;
          this.button.toggleAttribute('data-playing', playing);
          const label = playing ? this.button.dataset.pauseLabel : this.button.dataset.playLabel;
          this.button.setAttribute('aria-label', label);
          this.button.querySelector('span').textContent = label;
        };
        this.play = () => this.video.play().catch(() => this.updateControl());
        this.video.addEventListener('play', this.updateControl, options);
        this.video.addEventListener('pause', this.updateControl, options);
        this.button.addEventListener('click', () => {
          this.userPaused = !this.video.paused;
          if (this.userPaused) this.video.pause();
          else this.play();
        }, options);
        this.motion.addEventListener('change', () => {
          this.userPaused = this.motion.matches;
          if (this.userPaused) this.video.pause();
          else if (this.visible && !document.hidden) this.play();
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.video.pause();
          else if (this.visible && !this.userPaused) this.play();
        }, options);
        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          if (!this.visible) this.video.pause();
          else if (!this.userPaused && !document.hidden) this.play();
        }, { threshold: 0.05 });
        this.observer.observe(this.video);
        this.updateControl();
      }
      disconnectedCallback() {
        this.video?.pause();
        this.abort?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cove-welcome-offer"] && !Shopify.designMode) return;
  try {
    
function initCoveWelcome(){
 const root=document.querySelector('.cove-welcome');
 if(!root||root.dataset.ready)return;
 root.dataset.ready='true';
 const dialog=root.querySelector('dialog'),home=root.querySelector('.cove-welcome__home'),content=root.querySelector('.cove-welcome__form-content'),target=root.querySelector('.cove-welcome__dialog-form'),teaser=root.querySelector('.cove-welcome__teaser');
 const storage={get(key){try{return localStorage.getItem(key);}catch(e){return null;}},set(key,value){try{localStorage.setItem(key,value);}catch(e){}}};
 if(root.querySelector('.cove-welcome__success')){storage.set('cove-email-subscribed','1');root.querySelector('.cove-welcome__success').focus();return;}
 if(root.dataset.subscribed==='true'||storage.get('cove-email-subscribed')==='1')return;
 const start=Date.now(),week=7*24*60*60*1000;
 let shown=false,origin=null;
 const eligible=()=>!shown&&Date.now()-Number(storage.get('cove-email-dismissed')||0)>week&&!document.querySelector('dialog[open]')&&!/INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName||'');
 const open=(manual=false)=>{if(!manual&&!eligible())return;if(dialog.open)return;origin=document.activeElement;shown=true;target.append(content);teaser.hidden=true;dialog.showModal();};
 const dismiss=()=>{storage.set('cove-email-dismissed',String(Date.now()));home.append(content);teaser.hidden=false;if(origin&&typeof origin.focus==='function')origin.focus();};
 dialog.addEventListener('close',dismiss);
 root.querySelector('.cove-welcome__close').addEventListener('click',()=>dialog.close());
 dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
 teaser.addEventListener('click',()=>open(true));
 const inspect=()=>{if(Date.now()-start>=30000&&scrollY>=innerHeight*.75)open();};
 window.addEventListener('scroll',inspect,{passive:true});
 setTimeout(()=>{teaser.hidden=false;inspect();},30000);
 document.addEventListener('mouseout',event=>{if(matchMedia('(pointer:fine)').matches&&event.clientY<=0&&!event.relatedTarget&&Date.now()-start>=15000)open();});
}
initCoveWelcome();
document.addEventListener('shopify:section:load',initCoveWelcome);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
